<div class="p-5">
  <p>{{ errMsg }}</p>
  <p *ngIf="err">{{ err }}</p>
  <a class="nav-top-link" href="/">
    <i class="">{{ backToHomeMsg }}</i>
  </a>
</div>
